'use strict';
angular.module('TurneroApp').component('coCentroatencionOnline', {
    bindings: {
        usuario: '<'
    },
    controller: ['$window', '$state', '$rootScope', 'centrosAtencionService', '$scope', 'portal', 'agendaService', '$mdDialog', 'TurneroAppConstant', 'utilsService', 'unidadService', 'personaJuridicaService', 'agendasBloqueadasService', 'miDoctaModoService',
        function ($window, $state, $rootScope, centrosAtencionService, $scope, portal, agendaService, $mdDialog, TurneroAppConstant, utilsService, unidadService, personaJuridicaService, agendasBloqueadasService, miDoctaModoService) {
            var ctrl = this;
            ctrl.centros_Atencion = [];
            ctrl.centrosPagina = [];
            ctrl.loading = true;
            ctrl.textoBusqueda = '';
            ctrl.filtroAplicado = '';
            ctrl.Centro = { N_Centro_Atencion: '' };
            ctrl.pagination = { page: 1, total: 1, size: 3 };
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.layoutState = $state.$current.name.split('.')[0];
            ctrl.urlHome = ctrl.layoutState === 'ciudadanoPortal' ? 'turnosPortal' : 'turnos';
            ctrl.ConoceCentro = $rootScope.btnConoceCentro;
            ctrl.Id_Dependencia = null;
            ctrl.Id_Categoria = null;
            ctrl.UnidadGobierno = [];
            ctrl.Empresas = [];
            ctrl.Municipios = [];
            ctrl.ZonaSeleccionada = null
            ctrl.idVistos = []
            ctrl.opcionesFiltradas = []

            ctrl.centrosFiltrados = function () {
                var texto = (ctrl.filtroAplicado || '').toLowerCase().trim();
                return (ctrl.centros_Atencion || []).filter(function (centro) {
                    if (ctrl.ZonaSeleccionada && centro.Zona && centro.Zona.IdZona != ctrl.ZonaSeleccionada) {
                        return false;
                    }
                    if (!texto) {
                        return true;
                    }
                    var nombre = (centro.N_Centro_Atencion || '').toLowerCase();
                    var domicilio = (centro.Domicilio || '').toLowerCase();
                    return nombre.indexOf(texto) !== -1 || domicilio.indexOf(texto) !== -1;
                });
            };

            ctrl.refrescarPagina = function () {
                var filtrados = ctrl.centrosFiltrados();
                ctrl.pagination.total = Math.ceil(filtrados.length / ctrl.pagination.size) || 1;
                if (ctrl.pagination.page > ctrl.pagination.total) {
                    ctrl.pagination.page = 1;
                }
                var desde = (ctrl.pagination.page - 1) * ctrl.pagination.size;
                ctrl.centrosPagina = filtrados.slice(desde, desde + ctrl.pagination.size);
            };

            ctrl.aplicarBusqueda = function () {
                ctrl.filtroAplicado = ctrl.textoBusqueda || '';
                ctrl.Centro.N_Centro_Atencion = ctrl.filtroAplicado;
                ctrl.pagination.page = 1;
                ctrl.refrescarPagina();
            };

            ctrl.regresar = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);

                if (ctrl.layoutState === 'ciudadano') {
                    if (!$rootScope.btnConoceCentro && ctrl.Tramite && ctrl.Tramite.Id_Tramite) {
                        // Camino: alternativa -> tramites -> centros.
                        // Se conserva el tramite elegido para volver al listado anterior.
                        $rootScope.Id_Centro_Atencion = null;
                        $state.go(ctrl.layoutState + '.tramites');
                        return;
                    }

                    $rootScope.btnConoceCentro = false;
                    $rootScope.Id_Centro_Atencion = null;
                    $state.go(ctrl.layoutState + '.tramitealternativa');
                    return;
                }

                // Los accesos por portal no tienen pantalla de alternativa.
                $rootScope.$broadcast('esHome', true);
                $rootScope.btnConoceCentro = false;
                $rootScope.Id_Centro_Atencion = null;
                $window.location.href = miDoctaModoService.estaActivo()
                    ? miDoctaModoService.urlInternaConModo('/turnos')
                    : ctrl.urlHome + '/';
            };

            ctrl.limpiarMemoria = function () {
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
                ctrl.centros_Atencion = [];
                ctrl.centrosPagina = [];
                ctrl.Tramite = null;
            }

            ctrl.limpiarDatosAPIExterna = function () {
				ctrl.Agenda.APILink = null;
				ctrl.Agenda.Respuesta = null;
			}

            ctrl.$onInit = function () {
                ctrl.limpiarMemoria();
                ctrl.grillaReload();
            };

            $scope.$on('centrosLoad', function (event, tramite) {
                ctrl.Tramite = tramite;
            })

            ctrl.getUnidad = function () {
                unidadService.getUnidadCmb().$promise.then(function (result) {
                    ctrl.UnidadGobierno = result.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.getEmpresa = function () {
                personaJuridicaService.Get_Empresas_Combo().$promise.then(function (result) {
                    ctrl.Empresas = result.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.getMunicipio = function () {
                personaJuridicaService.Get_Municipios_Combo().$promise.then(function (result) {
                    ctrl.Municipios = result.Data;
                }).catch(function (error) {
                    utilService.errores(error);
                });
            };

            ctrl.grillaReload = function () {     
                if (ctrl.Tramite == null) {
                    ctrl.getTramiteSeleccionado();
                }

                //if (ctrl.Tramite != null && ctrl.Tramite.Id_Tramite != null) { //se saca la validacion para cuando sea null liste todos los centros
                centrosAtencionService.Get_X_Tramite({
                    'Id_Tramite_Relevado': ctrl.Tramite.Id_Tramite,
                    'Id_Categoria': ctrl.Id_Categoria,
                    'Id_Dependencia': ctrl.Id_Dependencia,
                    'Texto': ''
                }, function (result) {
                    ctrl.centros_Atencion = result.Data;
                    ctrl.opcionesFiltradas = []
                    ctrl.idsVistos = []
                    for (var i = 0; i < ctrl.centros_Atencion.length; i++) {
                        ctrl.centros_Atencion[i].Mapa = "assets/img/mapa" + Math.floor(Math.random() * (3 - 1 + 1) + 1) + ".png";
                    }
                    ctrl.centros_Atencion.forEach((centro)=>{
                        if (centro.Zona.IdZona > 0 && ctrl.idsVistos.indexOf(centro.Zona.IdZona) === -1) {
                            ctrl.opcionesFiltradas.push(centro);
                            ctrl.idsVistos.push(centro.Zona.IdZona);
                        }
                    })
                    ctrl.pagination.page = 1;
                    ctrl.refrescarPagina();
                    ctrl.loading = false;
                }, function (error) {
                    ctrl.loading = false;
                    sweetAlert("Oops...", "Ocurrió un error en la operación.</br> " + error.data.ExceptionMessage, "error");
                })
                //}
            };

            ctrl.getTramiteSeleccionado = function () {
                $rootScope.$broadcast('getTramiteSeleccionado');
            }

            ctrl.showMapa = function (Domicilio) {
                $window.open('https://www.google.com/maps/search/?api=1&query=' + Domicilio, '_blank');
            };

            ctrl.seleccionarCentro = function (centroSeleccionado, ev) {
                $rootScope.$broadcast('seleccionarCentro', centroSeleccionado);
                $rootScope.Id_Centro_Atencion = centroSeleccionado.Id_Centro_Atencion;

                if (!$rootScope.btnConoceCentro) { // si no conoce debe seguir el camino anterior e ir a la agenda
                    utilsService.swalTitle('Cargando Agendas', 'info');
                    agendaService.Get_Info_API({'id_tramite_relevado': ctrl.Tramite.Id_Tramite}).$promise.then(function (datosApi) {
						ctrl.Agenda = datosApi;
                        if(ctrl.Agenda.APILink != "" && ctrl.Agenda.Respuesta != "Iniciado")
						{
                            if (ctrl.Agenda.Respuesta && ctrl.Agenda.Respuesta.includes("_ADV")) {
                                swal({
                                    title: 'Atención',
                                    html: '¡Hemos detectado que Usted tiene un trámite de MI LICENCIA DIGITAL en curso!<br><br>Para retirar su licencia de conducir tramitada por la vía digital <a href="' + portal.getUrlServer() + 'turnos?tramitePortal=' + ctrl.Agenda.IdTramiteDigital + '">ingrese aquí</a>.<br><br>El trámite para el que está intentando sacar turno es \"' + ctrl.Tramite.N_Tramite + '\".<br><br>Por favor verifique que este trámite sea el que necesita.',
                                    type: 'warning',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                }).then(function () {
                                    ctrl.mostrarAgenda(centroSeleccionado, ctrl);
                                })
                            }
                            else
                            {
								swal({
									title: 'Atención',
									text: 'El tramite solicitado no esta disponible porque no tiene finalizada su gestión de licencia de conducir OnLine',
									type: 'warning',
									allowEscapeKey: false,
									allowOutsideClick: false,
									confirmButtonColor: '#004b81',
									confirmButtonText: "Aceptar",
								}).then(function () {
									$window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
								})
                                ctrl.limpiarDatosAPIExterna();
                            }
						}
                        else
                        {
                            ctrl.mostrarAgenda(centroSeleccionado, ctrl);
                        }
					}).catch(function (error) {
                        if (miDoctaModoService.estaActivo()) {
                            ctrl.mostrarAgenda(centroSeleccionado, ctrl);
                            return;
                        }
                        swal({
                            title: 'Atención',
                            text: 'Por un problema ajeno a esta plataforma, no hemos podido validar si posee un tramite de licencia online finalizado. Por favor vuelva a intentarlo mas tarde.',
                            type: 'warning',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar",
                        }).then(function () {
                            $window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
                            })
                    });
                    
                } else { //si conoce el centro debe listar los tramites de ese centro
                    $state.go(`${ctrl.layoutState}.tramites`);
                }
            };

            ctrl.mostrarAgenda = function (centroSeleccionado, ctrl) {
                if (!centroSeleccionado || !ctrl || !ctrl.Tramite) {
                    swal.close();
                    return;
                }
                agendaService.Get_x_Centro_Modalidad({ 'id_centro_atencion': centroSeleccionado.Id_Centro_Atencion, 'id_tramite_relevado': ctrl.Tramite.Id_Tramite, 'id_modalidad': ctrl.Modalidades.OnLine }).$promise.then(function (resultado) {
                    swal.close();
                    ctrl.Agenda = resultado.Data;
                    
                    // Filtrar agendas bloqueadas
                    var agendasBloqueadas = [];
                    ctrl.Agenda = ctrl.Agenda.filter(function (agenda) {
                        var mensajeBloqueo = agendasBloqueadasService.obtenerMensajeBloqueo(agenda.id || agenda.Id_Agenda, ctrl.Tramite.Id_Tramite);
                        if (mensajeBloqueo) {
                            agendasBloqueadas.push({ agenda: agenda, mensaje: mensajeBloqueo });
                            return false; // Excluir esta agenda
                        }
                        return true; // Incluir esta agenda
                    });
                    
                    // Mostrar warning si hay agendas bloqueadas (solo una vez)
                    if (agendasBloqueadas.length > 0) {
                        swal({
                            title: 'Atención',
                            html: agendasBloqueadas[0].mensaje,
                            type: 'warning',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar",
                        });
                    }
                    
                    if (ctrl.Agenda.length == 1) {
                        $rootScope.$broadcast('seleccionarAgenda', ctrl.Agenda[0], ctrl.Agenda);
                        $rootScope.$broadcast('esCalendario', true);
                        $state.go(ctrl.layoutState + '.calendario');
                    } else if (ctrl.Agenda.length > 1) {
                        $mdDialog.show({
                            template: require('./modalSeleccioneAgenda.html'),
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: false, // Only for -xs, -sm breakpoints.,
                            controllerAs: '$ctrl',
                            controller: function () {
                                return ctrl;
                            }
                        });

                    } else if (agendasBloqueadas.length === 0) {
                        sweetAlert("No hay agendas disponibles", 'Actualmente no hay agendas disponibles para este centro de atención. <br/> Inténtelo nuevamente con otro.', "warning");
                    }

                }).catch(function (error) {
                    swal.close();
                })
            }


            ctrl.cerrarModal = function () {
                $mdDialog.destroy();
            };

            ctrl.cambiarAgenda = function (agenda) {
                if (ctrl.agendaSeleccionada != null && ctrl.agendaSeleccionada != undefined) {
                    // Validar si la agenda seleccionada está bloqueada
                    var idAgenda = ctrl.agendaSeleccionada.id || ctrl.agendaSeleccionada.Id_Agenda;
                    var idTramite = ctrl.Tramite ? (ctrl.Tramite.Id_Tramite || ctrl.Tramite.Id_Tramite_Relevado) : null;
                    var mensajeBloqueo = agendasBloqueadasService.obtenerMensajeBloqueo(idAgenda, idTramite);
                    
                    if (mensajeBloqueo) {
                        // Mostrar warning y no permitir avanzar
                        swal({
                            title: 'Atención',
                            html: mensajeBloqueo,
                            type: 'warning',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar",
                        });
                        return; // No avanzar
                    }
                    
                    $rootScope.$broadcast('seleccionarAgenda', ctrl.agendaSeleccionada, ctrl.Agenda);
                    ctrl.cerrarModal();
                    $rootScope.$broadcast('esCalendario', true);
                    $state.go(ctrl.layoutState + '.calendario');
                } else {
                    sweetAlert("Debe seleccionar una agenda de las opciones", '', "warning");
                }
            }

            ctrl.copiarURL = function () {
                if (ctrl.Tramite.Id_Tramite) {
                    copiarAlPortapapeles($rootScope.urlHostServer + 'turnos?tramitePortal=' + ctrl.Tramite.Id_Tramite);
                    sweetAlert('¡URL Copiada!', 'Recuerde Iniciar Sesión en CiDi para poder ingresar a la URL.', 'success').catch(swal.noop);
                }
            }

            ctrl.changeDependencia = function (IdCategoria) {
                ctrl.Id_Categoria = IdCategoria;
                ctrl.grillaReload();
            };

            ctrl.limpiarCmb = function () {
                ctrl.ZonaSeleccionada = null;
                ctrl.grillaReload();
            };

            function copiarAlPortapapeles(elemento) {
                var $temp = $("<input>")
                $("body").append($temp);
                $temp.val(elemento).select();
                document.execCommand("copy");
                $temp.remove();
            }

        }],
    template: require('./turnoOnlineCentroAtencion.html')
});






// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/turnoOnlineCentroAtencionComponent.js